import { render } from "./BlogProjects.vue?vue&type=template&id=2288492e&scoped=true"
import script from "./BlogProjects.vue?vue&type=script&lang=js"
export * from "./BlogProjects.vue?vue&type=script&lang=js"

import "./BlogProjects.vue?vue&type=style&index=0&id=2288492e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2288492e"]])

export default __exports__